import { PopupItem } from "./popup-item";

export class HtmlPopupItem extends PopupItem {}